import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { detailsVacApp } from "../actions/vaccineAppointmentActions";
import PrintLayout from "../core/printLayout";
import PsychoLayout from "../core/psychoLayout";
import dayjs from "dayjs";
import Layout from "../core/Layout";

const options = [
    { id: 1, label: "session info" },
    { id: 2, label: "objectives" },
    { id: 3, label: "issues discussed" },
    { id: 4, label: "techniques used" },
    { id: 5, label: "observations" },
    { id: 6, label: "next session plan" },
];

const ViewTherapyRecordingReport = () => {
    const [therapyData, setTherapyData] = useState(null);
    const { id } = useParams();
    const navigate = useNavigate();
    const userLogin = useSelector((state) => state.userLogin);
    const { userInfo } = userLogin;
    const vaccineAppList = useSelector((state) => state.vaccineAppDetails);
    const { appointment: { appointment } = {} } = vaccineAppList || {};
    const dispatch = useDispatch();
    const [selectedOptions, setSelectedOptions] = useState(
        options.map((option) => option.label)
    );

    useEffect(() => {
        if (userInfo) {
            dispatch(detailsVacApp(id));
        } else {
            navigate("/signin");
        }
    }, [dispatch, userInfo]);

    useEffect(() => {
        setTherapyData(appointment?.therapySession);
    }, [appointment]);

    const calculateAge = (date) => {
        if (!date || date === "Invalid date") return 0;
        const birthMoment = dayjs(date);
        const today = dayjs();
        return today.diff(birthMoment, "years");
    };

    let therapyRecordingReport = () => {
        return `
    <div style="font-size:10px;">
    <div style="padding: 10px; max-width: 900px;font-size:12px;">
    <div>
    <h3 style="margin-bottom: 10px;">Therapy Session Recording Report</h3>
     <div style="font-size:14px">
          ${
              appointment &&
              appointment.patient &&
              `
          <div style="display: flex; justify-content: space-between; align-items: flex-start;">
            <div>
              <p>Name: <span>${
                  appointment.patient.firstName.toUpperCase() +
                  " " +
                  appointment.patient.lastName.toUpperCase()
              }</span></p>
              <p>Age: <span>${appointment.patient.age
      ? `${appointment.patient.age} years`
      : (appointment.patient.birthDate && appointment.patient.birthDate !== "Invalid date"
          ? `${calculateAge(appointment.patient.birthDate)} years`
          : "0 years")}</span></p>
            </div>
            <div>
              <p>Date: ${dayjs(Date.now()).format("DD-MM-YYYY")}</p>
              <p>Address: ${appointment.patient.address}</p>
            </div>
          </div>`
          }
          </div>

    ${
      selectedOptions.includes("session info") && therapyData
        ? `
          <div style="margin-top: 10px; padding: 8px; border: 1px solid #ddd; border-radius: 5px;">
            <h3 style="margin-bottom: 10px;">Session Information</h3>
            <div style="display: flex; flex-wrap: wrap; gap: 1rem;">
              ${therapyData.sessionNoDate ? `<div style="flex: 1 1 calc(33.33% - 1rem);"><strong>Session No. & Date:</strong> ${therapyData.sessionNoDate}</div>` : ""}
              ${therapyData.duration ? `<div style="flex: 1 1 calc(33.33% - 1rem);"><strong>Duration:</strong> ${therapyData.duration}</div>` : ""}
              ${therapyData.participants ? `<div style="flex: 1 1 calc(33.33% - 1rem);"><strong>Participants:</strong> ${therapyData.participants}</div>` : ""}
              ${therapyData.therapyMethod ? `<div style="flex: 1 1 100%;"><strong>Therapy Method:</strong> ${therapyData.therapyMethod}</div>` : ""}
            </div>
          </div>
        `
        : ""
    }

    ${
      selectedOptions.includes("objectives") &&
      therapyData?.objectives &&
      Object.values(therapyData.objectives).some((v) => v)
        ? `
          <div style="margin-top: 10px;">
            <h3 style="margin-bottom: 5px;">Session Objectives</h3>
            <ol style="padding-left: 20px;">
              ${therapyData.objectives.obj1 ? `<li>${therapyData.objectives.obj1}</li>` : ""}
              ${therapyData.objectives.obj2 ? `<li>${therapyData.objectives.obj2}</li>` : ""}
              ${therapyData.objectives.obj3 ? `<li>${therapyData.objectives.obj3}</li>` : ""}
            </ol>
          </div>
        `
        : ""
    }

    ${
      selectedOptions.includes("issues discussed") &&
      (therapyData?.selectedIssues?.length > 0 || therapyData?.customIssue)
        ? `
          <div style="margin-top: 10px;">
            <h3 style="margin-bottom: 5px;">Key Issues/Themes Discussed</h3>
            <div>
              ${therapyData.customIssue ? `<p style="margin-bottom: 10px;"><em>${therapyData.customIssue}</em></p>` : ""}
              ${
                therapyData.selectedIssues?.length > 0
                  ? `<div style="display: flex; flex-wrap: wrap; gap: 0.5rem;">
                      ${therapyData.selectedIssues
                        .map(
                          (issue) => `<span style="background-color: #f0f0f0; padding: 5px 10px; border-radius: 5px;">${issue}</span>`
                        )
                        .join("")}
                    </div>`
                  : ""
              }
            </div>
          </div>
        `
        : ""
    }

    ${
      selectedOptions.includes("techniques used") &&
      (therapyData?.selectedTechniques?.length > 0 || therapyData?.customTechnique)
        ? `
          <div style="margin-top: 10px;">
            <h3 style="margin-bottom: 5px;">Therapy Techniques Used</h3>
            <div>
              ${therapyData.customTechnique ? `<p style="margin-bottom: 10px;"><em>${therapyData.customTechnique}</em></p>` : ""}
              ${
                therapyData.selectedTechniques?.length > 0
                  ? `<div style="display: flex; flex-wrap: wrap; gap: 0.5rem;">
                      ${therapyData.selectedTechniques
                        .map(
                          (technique) => `<span style="background-color: #e8f5e9; padding: 5px 10px; border-radius: 5px;">${technique}</span>`
                        )
                        .join("")}
                    </div>`
                  : ""
              }
            </div>
          </div>
        `
        : ""
    }

    ${
      selectedOptions.includes("observations") && therapyData?.observations
        ? `
          <div style="margin-top: 10px;">
            <h3 style="margin-bottom: 5px;">Therapist Observations and Reflections</h3>
            <div style="padding: 8px; background-color: #fafafa; border-left: 3px solid #2196f3; border-radius: 5px;">
              ${therapyData.observations}
            </div>
          </div>
        `
        : ""
    }

    ${
      selectedOptions.includes("next session plan") &&
      (therapyData?.nextPlan || therapyData?.nextDate)
        ? `
          <div style="margin-top: 10px; padding: 8px; background-color: #fff3e0; border-radius: 5px;">
            <h3 style="margin-bottom: 5px;">Next Session Planning</h3>
            ${therapyData.nextPlan ? `<p><strong>Plan for Next Session:</strong> ${therapyData.nextPlan}</p>` : ""}
            ${therapyData.nextDate ? `<p><strong>Next Session Date:</strong> ${therapyData.nextDate}</p>` : ""}
          </div>
        `
        : ""
    }

    <div style="margin-top: 15px; padding: 10px;">
      <p style="font-weight: bold; margin: 0;">Signature: _______________________________</p>
    </div>

    </div>
    </div>
    </div>
      `;
    };

    const handleCheckboxChange = (label) => {
        setSelectedOptions((prevSelected) =>
            prevSelected.includes(label)
                ? prevSelected.filter((option) => option !== label)
                : [...prevSelected, label]
        );
    };

    return (
        <Layout>
            <div className="mt-4">
                {!therapyData ? (
                    <>
                        <p>No therapy session data available</p>
                        <button onClick={() => navigate(-1)}>Back</button>
                    </>
                ) : (
                    <>
                        <PsychoLayout
                            html={therapyRecordingReport}
                            category={"forms"}
                        ></PsychoLayout>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignContent: "flex-start",
                                gap: "20px",
                            }}
                        >
                            <div style={{ fontSize: "10px", width: "75%" }}>
                                <div style={{ padding: "10px", maxWidth: "900px", fontSize: "12px" }}>
                                    <div>
                                        <h3 style={{ marginBottom: "10px" }}>Therapy Session Recording Report</h3>
                                        <div style={{ fontSize: "14px" }}>
                                            {appointment?.patient && (
                                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                                                    <div>
                                                        <p>
                                                            Name:{" "}
                                                            <span>
                                                                {appointment.patient.firstName.toUpperCase()}{" "}
                                                                {appointment.patient.lastName.toUpperCase()}
                                                            </span>
                                                        </p>
                                                        <p>
                                                            Age:{" "}
                                                            <span>
                                                                {appointment.patient.age
                                                                    ? `${appointment.patient.age} years`
                                                                    : appointment.patient.birthDate &&
                                                                      appointment.patient.birthDate !== "Invalid date"
                                                                    ? `${calculateAge(appointment.patient.birthDate)} years`
                                                                    : "0 years"}
                                                            </span>
                                                        </p>
                                                    </div>
                                                    <div>
                                                        <p>Date: {dayjs(Date.now()).format("DD-MM-YYYY")}</p>
                                                        <p>Address: {appointment.patient.address}</p>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* Session Info */}
                                    {selectedOptions.includes("session info") && therapyData && (
                                        <div style={{ marginTop: "10px", padding: "8px", border: "1px solid #ddd", borderRadius: "5px" }}>
                                            <h3 style={{ marginBottom: "5px" }}>Session Information</h3>
                                            <div style={{ display: "flex", flexWrap: "wrap", gap: "1rem" }}>
                                                {therapyData.sessionNoDate && (
                                                    <div style={{ flex: "1 1 calc(33.33% - 1rem)" }}>
                                                        <strong>Session No. & Date:</strong> {therapyData.sessionNoDate}
                                                    </div>
                                                )}
                                                {therapyData.duration && (
                                                    <div style={{ flex: "1 1 calc(33.33% - 1rem)" }}>
                                                        <strong>Duration:</strong> {therapyData.duration}
                                                    </div>
                                                )}
                                                {therapyData.participants && (
                                                    <div style={{ flex: "1 1 calc(33.33% - 1rem)" }}>
                                                        <strong>Participants:</strong> {therapyData.participants}
                                                    </div>
                                                )}
                                                {therapyData.therapyMethod && (
                                                    <div style={{ flex: "1 1 100%" }}>
                                                        <strong>Therapy Method:</strong> {therapyData.therapyMethod}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}

                                    {/* Objectives */}
                                    {selectedOptions.includes("objectives") &&
                                        therapyData?.objectives &&
                                        Object.values(therapyData.objectives).some((v) => v) && (
                                            <div style={{ marginTop: "10px" }}>
                                                <h3 style={{ marginBottom: "5px" }}>Session Objectives</h3>
                                                <ol style={{ paddingLeft: "20px" }}>
                                                    {therapyData.objectives.obj1 && <li>{therapyData.objectives.obj1}</li>}
                                                    {therapyData.objectives.obj2 && <li>{therapyData.objectives.obj2}</li>}
                                                    {therapyData.objectives.obj3 && <li>{therapyData.objectives.obj3}</li>}
                                                </ol>
                                            </div>
                                        )}

                                    {/* Issues Discussed */}
                                    {selectedOptions.includes("issues discussed") &&
                                        (therapyData?.selectedIssues?.length > 0 || therapyData?.customIssue) && (
                                            <div style={{ marginTop: "10px" }}>
                                                <h3 style={{ marginBottom: "5px" }}>Key Issues/Themes Discussed</h3>
                                                <div>
                                                    {therapyData.customIssue && (
                                                        <p style={{ marginBottom: "10px" }}>
                                                            <em>{therapyData.customIssue}</em>
                                                        </p>
                                                    )}
                                                    {therapyData.selectedIssues?.length > 0 && (
                                                        <div style={{ display: "flex", flexWrap: "wrap", gap: "0.5rem" }}>
                                                            {therapyData.selectedIssues.map((issue, idx) => (
                                                                <span
                                                                    key={idx}
                                                                    style={{
                                                                        backgroundColor: "#f0f0f0",
                                                                        padding: "5px 10px",
                                                                        borderRadius: "5px",
                                                                    }}
                                                                >
                                                                    {issue}
                                                                </span>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )}

                                    {/* Techniques Used */}
                                    {selectedOptions.includes("techniques used") &&
                                        (therapyData?.selectedTechniques?.length > 0 || therapyData?.customTechnique) && (
                                            <div style={{ marginTop: "10px" }}>
                                                <h3 style={{ marginBottom: "5px" }}>Therapy Techniques Used</h3>
                                                <div>
                                                    {therapyData.customTechnique && (
                                                        <p style={{ marginBottom: "10px" }}>
                                                            <em>{therapyData.customTechnique}</em>
                                                        </p>
                                                    )}
                                                    {therapyData.selectedTechniques?.length > 0 && (
                                                        <div style={{ display: "flex", flexWrap: "wrap", gap: "0.5rem" }}>
                                                            {therapyData.selectedTechniques.map((technique, idx) => (
                                                                <span
                                                                    key={idx}
                                                                    style={{
                                                                        backgroundColor: "#e8f5e9",
                                                                        padding: "5px 10px",
                                                                        borderRadius: "5px",
                                                                    }}
                                                                >
                                                                    {technique}
                                                                </span>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )}

                                    {/* Observations */}
                                    {selectedOptions.includes("observations") && therapyData?.observations && (
                                        <div style={{ marginTop: "10px" }}>
                                            <h3 style={{ marginBottom: "5px" }}>Therapist Observations and Reflections</h3>
                                            <div
                                                style={{
                                                    padding: "8px",
                                                    backgroundColor: "#fafafa",
                                                    borderLeft: "3px solid #2196f3",
                                                    borderRadius: "5px",
                                                }}
                                            >
                                                {therapyData.observations}
                                            </div>
                                        </div>
                                    )}

                                    {/* Next Session Plan */}
                                    {selectedOptions.includes("next session plan") &&
                                        (therapyData?.nextPlan || therapyData?.nextDate) && (
                                            <div
                                                style={{
                                                    marginTop: "10px",
                                                    padding: "8px",
                                                    backgroundColor: "#fff3e0",
                                                    borderRadius: "5px",
                                                }}
                                            >
                                                <h3 style={{ marginBottom: "5px" }}>Next Session Planning</h3>
                                                {therapyData.nextPlan && (
                                                    <p>
                                                        <strong>Plan for Next Session:</strong> {therapyData.nextPlan}
                                                    </p>
                                                )}
                                                {therapyData.nextDate && (
                                                    <p>
                                                        <strong>Next Session Date:</strong> {therapyData.nextDate}
                                                    </p>
                                                )}
                                            </div>
                                        )}

                                        {/* Signature */}
                                        <div style={{ marginTop: "15px", padding: "10px" }}>
                                            <p style={{ fontWeight: "bold", margin: 0 }}>Signature: _______________________________</p>
                                        </div>
                                </div>
                            </div>

                            <div
                                style={{
                                    padding: "20px",
                                    fontFamily: "Arial, sans-serif",
                                    width: "20%",
                                }}
                            >
                                <h3 style={{ color: "#0288d1" }}>Select Sections:</h3>
                                {options.map((option) => (
                                    <div key={option.id} style={{ marginBottom: "10px" }}>
                                        <input
                                            type="checkbox"
                                            id={`checkbox-${option.id}`}
                                            value={option.label}
                                            checked={selectedOptions.includes(option.label)}
                                            onChange={() => handleCheckboxChange(option.label)}
                                        />
                                        <label
                                            htmlFor={`checkbox-${option.id}`}
                                            style={{
                                                marginLeft: "8px",
                                                color: "#424242",
                                                fontSize: "14px",
                                            }}
                                        >
                                            {option.label}
                                        </label>
                                    </div>
                                ))}
                                <div style={{ marginTop: "20px" }}>
                                    <h4 style={{ color: "#424242" }}>Selected Options:</h4>
                                    {selectedOptions.length > 0 ? (
                                        <ul
                                            style={{
                                                color: "#616161",
                                                fontSize: "14px",
                                            }}
                                        >
                                            {selectedOptions.map((option, index) => (
                                                <li key={index}>{option}</li>
                                            ))}
                                        </ul>
                                    ) : (
                                        <p
                                            style={{
                                                color: "#616161",
                                                fontSize: "14px",
                                            }}
                                        >
                                            No options selected.
                                        </p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </Layout>
    );
};

export default ViewTherapyRecordingReport;